import { Dice3Icon } from './Dice3Icon';

/**
 * author: Yasmina Lembachar
 * id 2948109E-F9DA-4306-8247-665CC05BDB21
 * name dice-3
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-3.svg
 * tags
 * - Gaming / RPG 
 */
export const Die3Icon = Dice3Icon;
export default Die3Icon